function initTagSlider(root = document) {
    root.querySelectorAll("[data-tag-slider]").forEach(section => {
        if (section.dataset.sliderBound === "1") return;

        const track = section.querySelector("[data-tag-slider-track]");
        const slides = Array.from(section.querySelectorAll("[data-tag-slide]"));
        const prevButtons = Array.from(section.querySelectorAll("[data-tag-slider-prev]"));
        const nextButtons = Array.from(section.querySelectorAll("[data-tag-slider-next]"));

        if (!track || slides.length <= 1) return;

        let index = 0;
        let autoplayId = null;
        const autoplayDelay = 3500;

        const update = () => {
            track.style.transform = `translateX(-${index * 100}%)`;
        };

        const goTo = nextIndex => {
            index = (nextIndex + slides.length) % slides.length;
            update();
        };

        const startAutoplay = () => {
            if (autoplayId) return;
            autoplayId = window.setInterval(() => {
                goTo(index + 1);
            }, autoplayDelay);
        };

        const stopAutoplay = () => {
            if (!autoplayId) return;
            window.clearInterval(autoplayId);
            autoplayId = null;
        };

        prevButtons.forEach(button => {
            button.addEventListener("click", () => {
                goTo(index - 1);
            });
        });

        nextButtons.forEach(button => {
            button.addEventListener("click", () => {
                goTo(index + 1);
            });
        });

        section.addEventListener("mouseenter", stopAutoplay);
        section.addEventListener("mouseleave", startAutoplay);
        section.addEventListener("focusin", stopAutoplay);
        section.addEventListener("focusout", startAutoplay);

        section.dataset.sliderBound = "1";
        update();
        startAutoplay();
    });
}

export default function initAllStories(root = document) {
    initTagSlider(root);
}
